// The consultation follows the current employment's Cobrar VT registration.
// A missing employment/flag has no transportation voucher charge.
export const matchesTransportationVoucherCharge = (employment = {}, filter = '', enabled = false) => {
  if (!enabled || !['true', 'false'].includes(filter)) return true;
  return (employment?.transportationVoucher === true) === (filter === 'true');
};
